<!-- 违背原因列表 -->
<template>
  <div>
    <van-row
      v-show="isShowTitle"
      class="noExitTip orange bg-lightColor"
      @click="isShow=true"
    >
      <van-col span="1">
        &nbsp;
      </van-col>
      <van-col span="1">
        <van-icon name="warning" />
      </van-col>
      <van-col span="21">
        <div class="van-ellipsis">
          出行提醒：受新冠疫情影响，各地疫情防控政策调控频繁，请在出行前务必与出发地、目的地、经停(转)地疫情管控相关单位进一步确认核酸检测报表时限要求以及落地管控政策，合理安排出行
        </div>
      </van-col>
    </van-row>
    <van-popup
      v-model="isShow"
      position="bottom"
      close-icon="close"
      :close-on-popstate="true"
      closeable
      round
      :get-container="getContainer"
      :style="{ bottom: bottom ,height: '500px'}"
    >
      <div class="violateList1 full-height">
        <van-cell :border="false">
          <div class="text-center font-bold font14">
            出行提醒
          </div> 
        </van-cell>
        <van-cell :border="false">
          <div class="font12 font-bold orange">
            出行提醒
          </div>
          <div class="font12 gray">
            受新冠疫情影响，各地疫情防控政策调控频繁，请在出行前务必与出发地、目的地、经停(转)地疫情管控相关单位进一步确认核酸检测报表时限要求以及落地管控政策，合理安排出行。
          </div>
        </van-cell>
        <div class="violatewrapper">
          <mescroll-vue
            ref="mescroll"
            :down="down"
          >
            <van-cell :border="false">
              <div v-html="cgContent" />
            </van-cell>
            <van-cell :border="false">
              <div v-html="rgContent" />
            </van-cell>
          </mescroll-vue>
          <van-cell>
            <ld-button
              main2
              size="md"
              round
              @click="closePopup"
            >
              知道了
            </ld-button>
          </van-cell>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>

import { Popup, Cell, RadioGroup, Radio, Field,CellGroup } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldButton from 'Common/ldButton'
import { mapGetters } from 'vuex'

export default {
  name: 'TravelTips',
  components: {
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    MescrollVue,
    ldButton
  },
  props: {
    depportCityid: {
      type: [ String ],
      default:''
    },
    arriveCityid: {
      type: [ String ],
      default:''
    },
    autoPopup:{
      type:Boolean,
      default:false
    },
    cplx: {// 产品类型，请求对应违背列表
      type: String,
      default: '10901'
    },
    element:{
      type: String,
      default: ''
    },
    bottom:{
      type: String,
      default: '0px'
    }
  },
  data() {
    return {
      isShow: false,
      isShowTitle: false,
      rgContent:'',
      cgContent:'',
      down:{use:false}
    }
  },
  computed:{
    ...mapGetters({
      tkTravelTips: 'tk/travelTips',
      trTravelTips: 'tk/travelTips',
    }),
  },
  mounted(){
    this.getList()
  },
  activated(){
  },
  deactivated (){
  },
  methods: {
    getList() {
      if(!this.depportCityid) return
      this.$api['common/getCxtxInfo']({
        cityId:this.depportCityid
      }).then(res => {
        var cache=res.data||{}
        if(cache.cgContent){
          this.isShowTitle=true
          this.cgContent =cache.cgContent
        }
        if(cache.tctx==1){//是否开启弹窗提醒 1-开启 2-不开启
          if(this.autoPopup){
            this.showAutoPopup()
          }
        }
      })
      if(this.arriveCityid){
        this.$api['common/getCxtxInfo']({
          cityId:this.arriveCityid
        }).then(res => {
          var cache=res.data||{}
          if(cache.rgContent){
            this.isShowTitle=true
            this.rgContent =cache.rgContent
          }
          if(cache.tctx==1){//是否开启弹窗提醒 1-开启 2-不开启
            if(this.autoPopup){
              this.showAutoPopup()
            }
          }
        })
      }
    },
    showAutoPopup(){
      if(this.cplx=='10901'){
        if(this.tkTravelTips.depportCityid==this.depportCityid&&this.tkTravelTips.arriveCityid==this.arriveCityid){
          return
        }else{
          this.tkTravelTips.depportCityid=this.depportCityid
          this.tkTravelTips.arriveCityid=this.arriveCityid
          this.isShow=true
        }
      }else if(this.cplx=='10904'){
        if(this.trTravelTips.depportCityid==this.depportCityid&&this.trTravelTips.arriveCityid==this.arriveCityid){
          return
        }else{
          this.trTravelTips.depportCityid=this.depportCityid
          this.trTravelTips.arriveCityid=this.arriveCityid
          this.isShow=true
        }
      }else{
        this.isShow=true
      }
    },
    closePopup(){
      this.$emit('close')
      this.toggle()
    },
    isShowCallBack(){
      if(this.rgContent||this.cgContent){
        return true
      }
      return false
    },
    // 返回一个特定的 DOM 节点，作为挂载的父节点
    getContainer() {
      if(this.element){
        return document.querySelector(this.element)
      }
      return ''
    },
    toggle() {
      this.isShow=!this.isShow
    }
  },
  watch:{
  }
}
</script>

<style  lang="less" scoped>
.violateList1 {
  .violatewrapper {
    height: 270px;
  }

  .pad8 {
    padding: 8px;
  }
  
  .cicle {
    width: 7px;
    height: 7px;
    margin-right: 10px;
    border-radius: 50%;
    background: @color-text-red;
  }
}
.noExitTip{
    padding:4px 8px;
    font-size: 10px;
    margin-bottom: 5px;
}
</style>
